import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import Header from "../../shared/Header";
import { useContext } from "react";
import { useNavigation } from "@/app/hooks/useNavigation"


const CompHeader = () => {
    const router = useNavigation()
    const { isIpad } = useContext(screenSizeContext)
    return (
        <div className="w-[100%] mb-4 lg:mb-6">
            <Header 
                title="What’s Happening"
                customTitleClass="lg:text-h2"
                buttonText={!isIpad ? "All Events" : undefined}
                isCenter={isIpad}
                buttonStyle="transparent"
                buttonTextStyle="!text-oBlack-100 border border-solid !border-oBlack-100 pe-10 leading-[1.05rem] tracking-[0.07rem]"
                buttonAction={() => { router.push("/media-center") }}
            />
        </div>
    );
}

export default CompHeader;